interface KYCImageDetail {
  label: string;
  value: string;
}

interface KYCImageDetails {
  title: string;
  items: Array<KYCImageDetail>;
}

interface IProps {
  details: KYCImageDetails;
}

export default function ImageDetails({
  details = { title: "", items: [] },
}: IProps) {
  return (
    <div>
      <div className="mb-4">
        <h3 className="font-medium px-2">{details.title}</h3>
      </div>
      <div className="w-full">
        {details?.items?.map((detail, detailIdx) => {
          return detail?.label ? (
            <div
              className="w-full h-auto flex items-center justify-between py-4 px-2 border-b border-gray-200"
              key={detailIdx}
            >
              <div className="w-4/12 text-xs block font-medium text-gray-500">
                {detail.label}
              </div>
              <div
                className="w-6/12 text-xs break-all"
                title={detail.value}
              >
                {detail.value}
              </div>
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
}
